<div class="row row-center">
    <div class="col-lg-4 col-md-6 col-12" style="position: fixed; bottom: 0; z-index: 200; height: unset;">
        <ngx-snackbar [max]="1" [position]="'bottom-center'" ></ngx-snackbar>
    </div>
</div>